import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GalaxyNavControlService {
  toggleEmitter$: EventEmitter<null> = new EventEmitter<null>();
  openEmitter$: EventEmitter<null> = new EventEmitter<null>();
  closeEmitter$: EventEmitter<null> = new EventEmitter<null>();
  closeForThisPage$: EventEmitter<null> = new EventEmitter<null>();
  undoCloseForThisPage$: EventEmitter<null> = new EventEmitter<null>();

  toggle(): void {
    this.toggleEmitter$.emit();
  }

  open(): void {
    this.openEmitter$.emit();
  }

  close(): void {
    this.closeEmitter$.emit();
  }

  closeForThisPage(): void {
    this.closeForThisPage$.emit();
  }

  undoCloseForThisPage(): void {
    this.undoCloseForThisPage$.emit();
  }
}
